<template>
  <div>
    <div
      v-if="loading"
      class="col-md-12 text-center"
      style="margin-top:25%"
    >
      <PulseLoader
        :loading="loading"
      ></PulseLoader>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12 ">
          <div class="x_panel">
            <div class="x_title">
              <h2>Vessel List</h2>
              <ul class="nav navbar-right panel_toolbox">
                <li v-if="isPermissionExist(PERMISSIONS.VESSEL_CREATE)">
                  <button type="button" class="btn btn-info btn-sm" @click="create">
                    Add New
                    <i class="fa fa-plus"></i>
                  </button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.VESSEL_PRINT)">
                  <button
                    @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                    <i class="fa fa-print" v-if="!isPrinting"></i>
                    <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                    {{ isPrinting ? 'Printing...' : 'Print' }}
                  </button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.VESSEL_PRINT)">
                  <vue-excel-xlsx
                    ref="excel"
                    :data="excelData"
                    :columns="excelHeader"
                    :file-name="'Vessel List'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    :disabled="isPrinting"
                    class="btn btn-primary btn-sm float-right"
                  >
                    <div
                      @click.prevent="handleExportPrint('excel')"
                    >
                      <i class="fa fa-file-excel-o"></i>
                      {{ isPrinting ? 'Preparing...' : 'Excel' }}
                    </div>
                  </vue-excel-xlsx>
                </li>
                <li>
                  <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                </li>
              </ul>
              <div class="clearfix"></div>
            </div>
            <div class="x_content table-responsive">
              <PerPageSelector
                v-model="offset"
                @change="onPerPageChange"
              />
                 <TableData
                   :listData="vessels?.data"
                   :currentPage="Number(vessels?.current_page)"
                   :perPage="Number(vessels?.per_page)"
                   :show="show"
                   :edit="edit"
                   :destroy="destroy"
                />

               <Pagination :pagination="vessels" :getData="getData"  />

              <div id="printArea" style="display: none">
                <div style="text-align: center;line-height: 20px;">
                  <h2 style="line-height: 10px;">{{ appName }}</h2>
                  <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                  <div style="line-height: 10px;" class="font-weight-bold">Vessel List</div>
                  <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                </div>
                <TableData :listData="printItems" :isPrinting="true"/>
              </div>

            </div>
          </div>
        </div>
      </div>


      <!-- Modal -->
      <div
        class="modal fade"
        id="roleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="customerModalLongTitle"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                class="modal-title"
                id="customerModalLongTitle"
              >{{ editMode ? "Edit" : "Add New" }} Vessel </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="editMode ? update() : store()" @keydown="form.onKeydown($event)">
              <div class="modal-body">
                <alert-error :form="form"></alert-error>
                <div class="row">
                  <div class="col-md-6 col-sm-6">
                    <div class="form-group">
                      <label>Vessel Name</label>
                      <input
                        v-model="form.name"
                        type="text"
                        name="name"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                      >
                      <has-error :form="form" field="name"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Email</label>
                      <input
                        v-model="form.email"
                        type="text"
                        name="name"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('email') }"
                      >
                      <has-error :form="form" field="email"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Imo Number :</label>
                      <input
                        v-model="form.imo_no"
                        type="text"
                        name="imo_no"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('imo_no') }"
                      >
                      <has-error :form="form" field="imo_no"></has-error>
                    </div>
                    <div class="form-group">
                      <label> Vessel Flag :</label>
                      <select v-model="form.flag_id" name="flag_id" class="form-control" :class="{ 'is-invalid': form.errors.has('flag_id') }">
                        <option value="" selected>Select Flag</option>
                        <option v-for="country in countryes" :key="country.id" :value="country.id">{{country.name}}</option>
                      </select>
                      <has-error :form="form" field="flag_id"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Breadth :</label>
                      <input
                        v-model="form.breadth"
                        type="text"
                        name="breadth"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('breadth') }"
                      >
                      <has-error :form="form" field="breadth"></has-error>
                    </div>
                    <div class="form-group">
                      <label> Vessel Build Yard :</label>
                      <input
                        v-model="form.build_yard"
                        type="text"
                        name="build_yard"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('build_yard') }"
                      >
                      <has-error :form="form" field="build_year"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Build Year :</label>
                      <input
                        v-model="form.build_year"
                        type="text"
                        name="build_year"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('build_year') }"
                      >
                      <has-error :form="form" field="build_year"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Engine Model :</label>
                      <input
                        v-model="form.engine_model"
                        type="text"
                        name="engine_model"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('engine_model') }"
                      >
                      <has-error :form="form" field="engine_model"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Type </label>
                      <select v-model="form.vessel_type_id" name="vessel_type_id" class="form-control" :class="{ 'is-invalid': form.errors.has('vessel_type_id') }">
                        <option value="">Select Vessel Type</option>
                        <option v-for="vesselType in vesselTypes" :key="vesselType.id" :value="vesselType.id">{{vesselType.name}}</option>
                      </select>
                      <has-error :form="form" field="vessel_type_id"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Owner name :</label>
                      <input
                        v-model="form.owner_name"
                        type="text"
                        name="owner_name"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('owner_name') }"
                      >
                      <has-error :form="form" field="owner_name"></has-error>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-6">


                    <div class="form-group">
                      <label>Manager name :</label>
                      <input
                        v-model="form.manager_name"
                        type="text"
                        name="manager_name"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('manager_name') }"
                      >
                      <has-error :form="form" field="owner_name"></has-error>
                    </div>

                    <div class="form-group">
                      <label>Vessel Length :</label>
                      <input
                        v-model="form.length"
                        type="text"
                        name="length"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('length') }"
                      >
                      <has-error :form="form" field="length"></has-error>
                    </div>

                    <div class="form-group">
                      <label>Vessel Classification Society :</label>
                      <input
                        v-model="form.classic_society"
                        type="text"
                        name="classic_society"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('classic_society') }"
                      >
                      <has-error :form="form" field="classic_society"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Engine Maker :</label>
                      <input
                        v-model="form.engine_maker"
                        type="text"
                        name="engine_maker"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('engine_maker') }"
                      >
                      <has-error :form="form" field="engine_maker"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Class No :</label>
                      <input
                        v-model="form.class_no"
                        type="text"
                        name="class_no"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('class_no') }"
                      >
                      <has-error :form="form" field="class_no"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Class Notation :</label>
                      <input
                        v-model="form.class_notation"
                        type="text"
                        name="class_notation"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('class_notation') }"
                      >
                      <has-error :form="form" field="class_notation"></has-error>
                    </div>
                    <div class="form-group">
                      <label>Vessel Image:</label>
                      <input type="file" class="form-control" @change="covertDocument" accept=".png, .jpg, .jpeg">
                      <input type="hidden" value="" id="itemImage">
                    </div>
                    <!--<div class="form-group">
                      <label>Vessel Status  </label>
                      <select v-model="form.status" name="status" class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                          <option value="Activate">Activate</option>
                          <option value="Deactivate">Deactivate</option>
                      </select>

                      <has-error :form="form" field="status"></has-error>
                    </div>-->
                  </div>
                </div>

              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Modal -->

      <!-- Modal -->
      <div
        class="modal fade"
        id="showModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="showModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="showModalLabel">{{ form.name }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover">
                  <tbody>
                  <tr>
                    <th>Name</th>
                    <td>{{ form.name }}</td>
                  </tr>
                  <tr>
                    <th>Image</th>
                    <td>
                      <img v-if="form.image!=null " :src="form.image" height="50" width="50"/>
                    </td>
                  </tr>
                  <tr>
                    <th>Imo Number</th>
                    <td>{{ form.imo_no }}</td>
                  </tr>
                  <tr>
                    <th>Length</th>
                    <td>{{ form.length }}</td>
                  </tr>
                  <tr>
                    <th>Class Society</th>
                    <td>{{ form.classic_society }}</td>
                  </tr>
                  <tr>
                    <th>Build Year</th>
                    <td>{{ form.build_year }}</td>
                  </tr>
                  <tr>
                    <th>Engine Maker</th>
                    <td>{{ form.engine_maker }}</td>
                  </tr>
                  <tr>
                    <th>Engine Model</th>
                    <td>{{ form.engine_model }}</td>
                  </tr>
                  <tr>
                    <th>Engine Model</th>
                    <td>{{ form.class_no }}</td>
                  </tr>
                  <tr>
                    <th>Engine Model</th>
                    <td>{{ form.class_notation }}</td>
                  </tr>

                  <tr>
                    <th>Status</th>
                    <td>{{ form.status }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="row">
                <div class="col-md-6"></div>
                <div class="col-md-6"></div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import datetime from 'vuejs-datetimepicker';
    import Select2 from "v-select2-component";
    import auth from "@/auth";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import TableData from "./TableData.vue";
    import {apiPrintData} from "@/utils/print";
    import PermissionsMixin from "@/mixin/permissionsMixin";

    export default {
        name: "Vessel",
        mixins: [PermissionsMixin, goBackButtonMixin],
        components: {datetime, PulseLoader, TableData},
        data() {
            return {
                loading: false,
                editMode: false,
                vesselId: auth.getVesselId(),
                offset: 20,
                isPrinting: false,
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                printItems: [],
                query: "",
                queryFiled: "name",
                vessels: [],
                vesselTypes: [],
                excelHeader: [],
                excelData: [],
                countryes: [],
                form: new Form({
                    id: "",
                    name: "",
                    email: "",
                    vessel_type_id: "",
                    imo_no: "",
                    flag_id: '',
                    build_yard: '',
                    owner_name: '',
                    manager_name: '',
                    length: "",
                    breadth: "",
                    classic_society: "",
                    build_year: "",
                    engine_maker: "",
                    engine_model: "",
                    class_name: '',
                    class_no: '',
                    class_notation: '',
                    image: '',
                    status: "Activate",
                }),
                cftForm: new Form({
                    name: "",
                }),
                pagination: {
                    current_page: 1
                }
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
          onPerPageChange() {
            this.getData(1);
          },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Vessel Id': `${item?.id || ''}`,
                'Name': `${item?.name || ''}`,
                'Email': `${item?.email || ''}`,
                'Vessel Type': `${item?.vessel_type?.name || ''}`,
                'Vessel Model': `${item?.engine_model || ''}`,
                'Build Year': `${item?.build_year || ''}`,
                'Status': `${item?.status == 'Activate' ? 'Active' : 'Inactive'}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                is_all: 1,
                offset : this.offset,
              };

              const res = await this.$http.get('/api/vessel', {params});
              const dataList = res?.data?.success?.vessel ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Vessel List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            getData(page = 1) {
              var params = {
                page: page,
                is_all: 0,
                offset : this.offset,
              }
                this.loading = true;
                this.$http.get("/api/vessel", {params}).then(response => {
                    this.loading = false;
                    this.vessels = response.data.success.vessel;

                    this.vesselTypes = response.data.success.vesselType;
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                });
            },
            allCountry() {
                //  country
                this.$http.get("/api/country").then(response => {
                    this.countryes = response.data.success;
                    setTimeout(() => $('#datatables').DataTable(), 1000);
                }).catch(e => {
                    console.log(e);
                });
            },
            covertDocument(event) {
                let file = event.target.files[0];
                this.form.image = file;
            },
            create() {
                this.editMode = false;
                this.form.reset();
                this.form.clear();
                this.allCountry();
                $("#roleModal").modal("show");
            },
            store() {
                this.form.busy = true;
                this.form.post("/api/vessel").then(response => {
                  this.getData(Number(this.vessels?.current_page))
                  $("#roleModal").modal("hide");
                    if (this.form.successful) {
                        this.$snotify.success("Vessel Successfully Saved");
                    } else {
                        this.$Snotify.error("Something went wrong try again later.", "Error");
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                });
            },
            edit(vessel) {
                this.editMode = true;
                this.form.reset();
                this.form.clear();
                this.form.fill(vessel);
                this.allCountry();
                $("#roleModal").modal("show");
            },
            update() {
                this.form.busy = true;
                this.form._method = 'put';
                this.form.post("/api/vessel/" + this.form.id).then(response => {
                  this.getData(Number(this.vessels?.current_page))
                  $("#roleModal").modal("hide");
                    if (this.form.successful) {
                        this.$snotify.success("Vessel Successfully Updated");
                    } else {
                        this.$snotify.error("Something went wrong try again later.", "Error");
                    }
                }).catch(e => {
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                });
            },
            show(vessel) {
                this.form.reset();
                this.form.fill(vessel);
                $("#showModal").modal("show");
            },
            destroy(vessel) {
                this.$dialog.confirm('Do You Want to delete This ?').then(() => {
                    this.$http.delete("/api/vessel/" + vessel.id).then(response => {
                      this.getData(Number(this.vessels?.current_page))
                      this.$snotify.success("Vessel Successfully Deleted");
                    }).catch(e => {
                        let response = e.response;
                        if (response.status === 403) {
                            this.$snotify.warning(response?.data?.error)
                        } else {
                            this.$snotify.error("Vessel Not Deleted", "error");
                        }
                    });
                }).catch(function () {

                });
            },
        }
    }
</script>

<style scoped>

</style>
